var currentUrlArr = location.pathname.split("/");
var actor = currentUrlArr[1];
var page = currentUrlArr[2];
if (page == 'reports') {
    var page_id = 'report';
    var regist_url = 'registReportOwnFile';
    var remove_url = 'removeReportOwnFile';
} else if (page == 'invoices') {
    var page_id = 'invoice';
    var regist_url = 'registInvoiceOwnFile';
    var remove_url = 'removeInvoiceOwnFile';
}
// 実費処理
$(() => {
    // 領収書ファイルUP処理
    $(document).on('click', '.js-own-exec', function(){
        $(this).prop('disabled', true);
        $('.own_error').remove();
        let fileEntity = $('input[name=own_file]').prop('files')[0];
        if (fileEntity) {
            let formData = new FormData();
            formData.append(page_id+'_id', $('#js-own-id').val());
            formData.append("own_file", fileEntity);
            $.ajax({
                url: '/'+actor+'/ajax/'+regist_url,
                type: 'POST',
                processData: false,
                contentType: false,
                dataType : 'json',
                data: formData
            }).done(function(data, textStatus, jqXHR) {
                $('#own_modal').modal('hide');
                $('.own_error').remove();
                $('input[name=own_file]').val(null);
                $('.js-own-exec').prop('disabled', false);
                $('#js-own-files').append( addedFileTemplate(fileEntity.name,data) );
            }).fail(function(jqXHR, textStatus, errorThrown ) {
                $('#own_form').append('<div class="own_error"><span class="invalid-feedback" role="alert">アップロードができませんでした。ファイルを確認してください。</span></div>');
                $('.js-own-exec').prop('disabled', false);
            }).always(function(){
            });
        } else {
            $('#own_form').append('<div class="own_error"><span class="invalid-feedback" role="alert">アップロードができませんでした。ファイルを確認してください。</span></div>');
            $('.js-own-exec').prop('disabled', false);
        }
    });

    $(document).on('click', '.js-own-file-remove', function(){
        let fileId = $(this).closest('.js-own-file').data('file-id');
        $('.js-own-remove-exec').data('file-id', fileId);
        $('#own_remove_modal').modal('show');
    });

    $(document).on('click', '.js-own-remove-exec', function(){
        let fileId = $(this).data('file-id');
        $('.own_file').filter('[data-file-id="' + fileId + '"]').remove();
        ajaxRemoveOwnFile(fileId);
        $('#own_remove_modal').modal('hide');
    });

    // Ajaxファイル削除
    function ajaxRemoveOwnFile(fileId) {
        $.ajax({
            url: '/'+actor+'/ajax/'+remove_url,
            type: 'POST',
            dataType : 'json',
            data: {
                file_id:fileId
            },
        }).done(function(data, textStatus, jqXHR) {
            return true;
        }).fail(function(jqXHR, textStatus, errorThrown ) {
            return false;
        }).always(function(){
            return false;
        });
    }

    // ファイル選択時のファイル名表示テンプレート
    var addedFileTemplate = function(filename, data) {
        let template = '<div class="own_file js-own-file d-inline-block attached_file mr-2 mb-1" data-file-id="'+data.id+'" data-registed="">'
        template = template + '<i class="far fa-file"></i>'
        template = template + '<span class="own_file_name px-1"><a href="/'+actor+'/download/'+data.path+'">'+filename+'</a></span>'
        template = template + '<span class="own_file_remove js-own-file-remove"><i class="fas fa-times"></i></span>'
        template = template + '</div>'
        return template
    }
});
